import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { GroupService } from '../../group.service';

@Component({
  selector: 'app-edit-group',
  templateUrl: './edit-group.component.html',
  styleUrls: ['./edit-group.component.scss']
})
export class EditGroupComponent implements OnInit {

  Form: FormGroup;
  organizationData: any;

  constructor(
    private fb:FormBuilder,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditGroupComponent>,
    private groupService: GroupService
  ) {
    const d = this.data;
    console.log(d);
    this.Form = this.fb.group
    ({
      name: [d && d.name?d.name:'',Validators.required],
      orgId: [d && d.orgId?d.orgId:'',Validators.required],
      active: [d && d.active?d.active:true],

    });

  }

  ngOnInit(): void {
    this.getOrganization();
  }

  get f(){
    return this.Form.controls;
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
      else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  async getOrganization(){
    await this.groupService.getOrganization().subscribe(data => {
     if(data.length > 0){
      this.organizationData = data;
      console.log(this.organizationData);
     }
     });

   }

  async onSubmit(){
    console.log(this.Form.value);
    await this.groupService.addEditGroup(this.Form.value, this.data?this.data.id: '');
    this.dialogRef.close();
    // this.http.addEditBlog(this.Form.value).subscribe((res)=>{
    //   if(res.success){
    //     this.dialog.open(SuccessComponent,{
    //       data:{
    //         title:"Updated!",
    //         subTitle:"Blog updated successfully."
    //       },
    //     });
    //     this.dialogRef.close();
    //   }
    //   this.spinner.hide();
    // },
    // err => {
    //   console.log('HTTP Error', err);
    //   this.spinner.hide();
    //   alert('Something went wrong,please try again');
    // },
    // )
  }
}
